export default "/images/volume.png?7a3efd5d23906234e25c2bfa3c68a324";